export default "/assets/comments-error-blankstate-6410e5d4238498b5b86b38b1da5418f7f071872789136e8bad6b3a38ca9308f2.svg";